/**
 * @enum LvfHandlingType
 *  * @classdesc Represents the supported equipment handling type.
 */
export enum LvfHandlingType {

  FORKLIFT = 1,
  FORK_EMBEDDED = 2,
  ELECTRIC_PALLET_DOCK = 3,
  MANUAL_PALLET_TRUCK = 4,
  ELECTRIC_PALLET_DRIVER = 5,
}
